module.exports = __webpack_public_path__ + "00ea231965e9abeeb557fe964aa4c2dc.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/beak/mustache-white-s.png
// module id = 1209
// module chunks = 0